import { useState, useEffect } from "react";

const getDevice = () => {
  if (window.innerWidth > 1279) return "desktop";
  if (window.innerWidth < 480) return "mobilePortrait";
  return "mobile";
};

function useDevice() {
  const [device, setDevice] = useState(getDevice);

  useEffect(() => {
    const updateDevice = () => {
      setDevice(getDevice());
    };

    window.addEventListener("resize", updateDevice);
    return () => window.removeEventListener("resize", updateDevice);
  }, []);

  return device;
}

export default useDevice;
